import { IBlogState } from "../../types/blogTypes";
import {
  GET_BLOGS,
  GET_BLOG_DETAILS,
  GET_META_TAGS,
  RESET_BLOG_DETAILS,
  SET_BLOG_DETAIL_STATUS,
  SET_BLOG_LIST_STATUS,
  SET_FEATURED_BLOGS,
  SET_FEATURED_TRENDING_BLOGS,
  SET_HOME_MOSAIC_BLOGS,
  SET_SAVED_BLOGS,
  SET_TRENDING_BLOGS,
} from "../constants/blogConstants";

const init: IBlogState = {
  blogs: {
    paginate: 25,
    total: 0,
    data: [],
    per_page: 25,
  },
  blogDetails: null,
  meta_tags: [],
  listStatus: false,
  detailStatus: false,
  homeMosaicBlogs: [],
  trendingBlogs: [],
  featuredBlogs: [],
  featuredTrendingBlogs: {
    featured: [],
    trending: [],
  },
  savedBlogs: [],
  blogStatus: false,
};

const blogReducer = (state: IBlogState = init, action: any): IBlogState => {
  switch (action.type) {
    case GET_BLOGS: {
      return {
        ...state,
        blogs: action.payload.data,
        listStatus: true,
      };
    }
    case GET_BLOG_DETAILS: {
      return {
        ...state,
        blogDetails: action.payload.data,
        detailStatus: true,
      };
    }
    case SET_BLOG_LIST_STATUS: {
      return {
        ...state,
        listStatus: false,
      };
    }
    case SET_BLOG_DETAIL_STATUS: {
      return {
        ...state,
        detailStatus: false,
      };
    }
    case GET_META_TAGS: {
      return {
        ...state,
        meta_tags: action.payload.data,
      };
    }
    case RESET_BLOG_DETAILS: {
      return {
        ...state,
        blogDetails: null,
        detailStatus: false,
      };
    }
    case SET_HOME_MOSAIC_BLOGS: {
      return {
        ...state,
        homeMosaicBlogs: action.payload,
      };
    }
    case SET_FEATURED_BLOGS: {
      return {
        ...state,
        featuredBlogs: action.payload,
      };
    }
    case SET_TRENDING_BLOGS: {
      return {
        ...state,
        trendingBlogs: action.payload,
      };
    }
    case SET_FEATURED_TRENDING_BLOGS: {
      return {
        ...state,
        featuredTrendingBlogs: action.payload.data,
      };
    }
    case SET_SAVED_BLOGS: {
      return {
        ...state,
        savedBlogs: action.payload?.data,
        blogStatus: true,
      };
    }
    default:
      return state;
  }
};
export default blogReducer;
